import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const createGbSubmissionRequest = payload =>
  actionRequestFactory(types.CREATE_GB_SUBMISSION_REQUEST, payload);
export const createGbSubmissionSuccess = submission =>
  actionResponseFactory(types.CREATE_GB_SUBMISSION_SUCCESS, { submission });
export const createGbSubmissionFailure = error =>
  actionResponseFactory(types.CREATE_GB_SUBMISSION_FAILURE, { error });

export const createDESubmissionRequest = payload =>
  actionRequestFactory(types.CREATE_DE_SUBMISSION_REQUEST, payload);
export const createDESubmissionSuccess = submission =>
  actionResponseFactory(types.CREATE_DE_SUBMISSION_SUCCESS, { submission });
export const createDESubmissionFailure = error =>
  actionResponseFactory(types.CREATE_DE_SUBMISSION_FAILURE, { error });
